import LandingPage, { type LandingPageContent } from '../LandingPage';

const content: LandingPageContent = {
  eyebrow: 'Strategic Downsizing',
  headline: 'Stop Maintaining a Life That No Longer Fits.',
  subhead:
    'Your home served you well. But when the rooms are empty and the upkeep feels heavier than the memories, it might be time to trade square footage for freedom.',
  truth:
    'Downsizing isn\'t about losing something. It\'s about realigning.\n\nBut here\'s what nobody tells you: selling a luxury home you\'ve owned for years is nothing like buying one. The market has changed. Your equity position is different. And the decision isn\'t just financial — it\'s deeply personal.\n\nYou don\'t need someone who rushes you through it. You need someone who helps you see the full picture first.',
  clarityPoints: [
    'Accurate valuation based on current market data — not what Zillow guesses.',
    'Four selling strategies compared side-by-side: speed, simplicity, profit, or a hybrid approach.',
    'Strategic renovation funding to maximize your equity without spending a dime upfront.',
    'Private sale channels for homeowners who prefer discretion over open houses.',
    'Full transition support — from packing and moving to closing and beyond.',
  ],
  calm:
    'You\'ve earned the right to do this on your terms.\nNo rush. No pressure. Just clarity about what each path looks like.\n\nYour personalized report puts every option in front of you — so you can choose the one that feels right.',
  ctaText: 'Get My Strategy Report',
  pullQuote: 'Making room for what\'s next isn\'t losing — it\'s realigning.',
  utmSource: 'sell-downsizing',
};

export default function SellDownsizingPage() {
  return <LandingPage content={content} />;
}
